import moment from 'moment';

// IMPORT PACKAGE REFERENCES

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';


// COMPONENT

class DeviceListItem extends React.Component {

    constructor(props) {
        super(props);
    }

    getPharmacy(device) {
        if (device.hasOwnProperty("pharmacy")) {
            let pharmacy = device.pharmacy;
            let inactive = false;

            // Check the devices currently/previously attached to the pharmacy.
            let pharmacyDevices = pharmacy.deviceUuids;

            if (pharmacyDevices.hasOwnProperty(device.deviceName)) {
                inactive = pharmacyDevices[device.deviceName].hasOwnProperty('dateRemoved');
            }

            // Only return the currently attached pharmacy, if the device hasn't been removed from that pharmacy.
            if (!inactive && device.pharmacy.hasOwnProperty("campaignName")) {
                return device.pharmacy.campaignName;
            }
        }

        return ""
    }

    getPharmacyId(device) {
        if (device.hasOwnProperty("pharmacy")) {
            if (device.pharmacy.hasOwnProperty("id")) {
                return encodeURI(device.pharmacy.id);
            }
        }

        return ""
    }
    
    getLatestEvent(device) {
        if (device.hasOwnProperty("latestEvents")) {
            if (device.latestEvents.length > 0) {
                var now = moment(new Date()); //todays date
                var end = moment(device.latestEvents[0].latest, "HH:mm:ss ddd DD-MM-YYYY"); // another date
                var duration = moment.duration(now.diff(end));
    
                var minutes = duration.asMinutes();
                var hours = duration.asHours();
                var days = duration.asDays();
    
                if (days < 1) {
                    if (hours < 1) {
                        return Math.round(minutes) + " minutes ago";
                    } else {
                        return Math.round(hours) + " hours ago";
                    }
                } else {
                    return Math.round(days) + " days ago";
                }
            }
        }
        return "";
    }

    getDeviceBatteryPercentage(device) {
        if (device.hasOwnProperty("DeviceDetails")) {
            if (device.DeviceDetails.hasOwnProperty("dynamicDevice")) {
                if (device.DeviceDetails.dynamicDevice.hasOwnProperty("batteryLevel")) {
                    let level = Math.round(device.DeviceDetails.dynamicDevice["batteryLevel"] * 100);

                    if (level < 10) {
                        return <span className="badge badge-danger">{ level + "%" }</span>
                    } else if (level < 25) {
                        return <span className="badge badge-warning">{ level + "%" }</span>
                    } else {
                        return <span className="badge badge-success">{ level + "%" }</span>
                    }
                }
            }
        }
    }

    getNetwork(device) {
        if (device.hasOwnProperty("DeviceDetails")) {
            if (device.DeviceDetails.hasOwnProperty("dynamicDevice")) {
                if (device.DeviceDetails.dynamicDevice.hasOwnProperty("networkStatus")) {
                    return device.DeviceDetails.dynamicDevice["networkStatus"]
                }
            }
        }
    }

    getPowerState(device) {
        if (device.hasOwnProperty("DeviceDetails")) {
            if (device.DeviceDetails.hasOwnProperty("dynamicDevice")) {
                if (device.DeviceDetails.dynamicDevice.hasOwnProperty("powerState")) {
                    return device.DeviceDetails.dynamicDevice["powerState"]
                }
            }
        }
    }

    getCreationDate(device) {
        if (device.hasOwnProperty("TimeSet")) {
            return moment(device.TimeSet, "HH:mm ddd DD-MM-YYYY").format("DD-MM-YYYY");
        }
    }

    render() {
        const { device } = this.props;

        return (
            <div className="list-item">
                <div className="row">
                    <div className="col-2">
                        <NavLink className="device-link" to={'/device/' + device.LatestSetupPharmacyId}>{ device.LatestSetupPharmacyId }</NavLink>
                    </div>
                    <div className="col-3">
                        <NavLink to={'/pharmacy/' + this.getPharmacyId(device)}>{ this.getPharmacy(device) }</NavLink>
                    </div>
                    <div className="col-1">
                        { this.getDeviceBatteryPercentage(device) }
                    </div>
                    <div className="col-1">
                        { this.getNetwork(device) }
                    </div>
                    <div className="col-1">
                        { this.getPowerState(device) }
                    </div>
                    <div className="col-2">
                        <small class="text-muted">{ this.getCreationDate(device) }</small>
                    </div>
                    <div className="col-2">
                        <small class="text-muted">{ this.getLatestEvent(device) }</small>
                    </div>
                </div>
            </div>
        )
    }
}


DeviceListItem.propTypes = {
    device: PropTypes.object.isRequired,
};

export default DeviceListItem;